import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import api from "./services/api";
import { login } from "./services/auth";

export default function Login({ history }) {
  const initialState = {
    email: "",
    password: ""
  };

  const [user, setUser] = useState(initialState);
  const [errors, setErrors] = useState([]);
  const [transform, setTransform] = useState('')

  useEffect(() => {
      window.addEventListener('scroll', handleScroll);
    }, []);


  const handleScroll = (e) => {
    let r = (window.scrollY);
    let u = r/6
    setTransform(u)
  }

  const handleInputs = e => {
    setUser({
      ...user,
      [e.target.name]: e.target.value
    });
  };

  const handleSave = async e => {
    e.preventDefault();
    const { email, password } = user;

    if (!email.trim() || !password.trim()) {
      console.log(`Please complete all fields`);
      return;
    }

    try {
      const res = await api.post("/auth", { email, password });
      if (res.status === 200) {
        const { token } = res.data;
        login(token);
        window.location = `/home`
      }
    } catch (err) {
      setErrors(err.response.data.message);
    }
  };


  const [loginButton, setLoginButton] = useState(false);
  const [signupButton, setSignupButton] = useState(false);



  let buttonStyleFalse = {
    padding: '10px',
    margin: '30px 0 0 0',
    width: '130px',
    border: '1px solid #fff',
    borderRadius: '4px',
    textTransform: 'uppercase',
    fontWeight: '400',
    textAlign: 'center',
    background: '#80a3db',
    color: '#fff',
    textDecoration: 'none',
  }

  let buttonStyleTrue = {
    padding: '10px',
    margin: '30px 0 0 0',
    width: '130px',
    border: '1px solid #fff',
    borderRadius: '4px',
    textTransform: 'uppercase',
    fontWeight: '400',
    textAlign: 'center',
    background: '#fff',
    color: '#80a3db',
    textDecoration: 'none',
  }

  let inputStyle = {
    width: '300px',
    height: '30px',
    fontSize: '16px',
    border: '1px solid lightgray',
    borderRadius: '5px',
    margin: '5px 0 0 0',
    padding: '5px 5px 5px 15px',
  }

  let warnStyle ={
    fontSize: '17px',
    margin: '3px 0 0 0',
    fontWeight: '600',
    color: '#F25835',
  }

  return (
    <div>    
      <div style={{display: 'flex'}}>
          <div style={{width: '7vw'}}></div>
          <div
            style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '84vw',
          }}>
            <h1
              style={{
                fontSize: '80px',
                fontWeight: '400',
                color: '#FFF',
                margin: '40px 0 40px 0',
                width: '100%',
                textAlign: 'center',
              }}
              >
              Welcome Back!
            </h1>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '0 0 50px 0'
              }}>
              <form
                onSubmit={handleSave}
                style={{
                  width: '300px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                >
                <input
                  type="text"
                  name="email"
                  autoFocus
                  value={user.email}
                  onChange={handleInputs}
                  placeholder="Email"
                  style={inputStyle}
                />
                <input
                  type="password"
                  name="password"
                  value={user.password}
                  onChange={handleInputs}
                  placeholder="Password"
                  style={inputStyle}
                  onKeyDown={ (e) => (
                      e.keyCode === 13
                        ? handleSave(e)
                        : null
                      )}
                />
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}>
                  <button
                    style={
                      loginButton === true
                      ? buttonStyleTrue
                      : buttonStyleFalse
                    }
                    onClick={(e)=>handleSave(e)}
                    onMouseEnter={() => setLoginButton(true)}
                    onMouseLeave={() => setLoginButton(false)}
                    >
                      Login
                  </button>
                </div>
                <p style={warnStyle}>{errors}</p>
              </form>
            </div>
            <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '0 0 300px 0',
            }}>
              <div>
                <p
                  style={{
                    fontSize: '30px',
                    fontWeight: '400',
                    color: '#FFF',
                    margin: '80px 0 -10px 0',
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  New?
                </p>
                <Link
                  to='/signup'
                >
                  <button
                    style={
                      signupButton === true
                      ? buttonStyleTrue
                      : buttonStyleFalse
                    }
                    onMouseEnter={() => setSignupButton(true)}
                    onMouseLeave={() => setSignupButton(false)}
                    >
                      Sign-up
                  </button>
                </Link>
              </div>
            </div>
          </div>
        <div style={{width: '7vw'}}></div>
      </div>
    </div>
  );
}



